import {MSG_ERRO_SERVIDOR} from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    mensagem:'',
    dados: null,
    esperandoSolicitacao: false,
    erroSolicitacao: false,
    error_elo: false,
    urlRedirect: "",
};

export default (state= INITIAL_STATE, action) =>{
    switch(action.type){

        case 'ART29_ERRO_RECEBIDO':
            return {...state, 
                mensagem: (typeof action.payload == "string") ? action.payload : MSG_ERRO_SERVIDOR,
                esperandoSolicitacao: false,
                erroSolicitacao: true,
                error: action.error};

        case 'ART29_REVISAO_SOLICITADA':
            return {...state, esperandoSolicitacao: true, mensagem: '', erroSolicitacao: false, urlRedirect: "" };

        case 'ART29_REVISAO_RECEBIDA':
            return {...state, dados: action.payload, esperandoSolicitacao: false};

        case 'ART29_NAO_ENCONTRADO':
            return {...state, esperandoSolicitacao: false, error_elo: false, mensagem: 'Consulta a Revisão artigo 29 não retornou dados para o cidadão.'}

        case 'ART29_IMPRESSAO_SOLICITADA':
            return {...state, esperandoImpressao: true, error: false, error_elo: false, mensagem: '', urlRedirect: ""};

        case 'ART29_IMPRESSAO_RECEBIDA':
            return { ...state, esperandoImpressao: false, urlRedirect: '/artigo29/pdf-download' };

        case 'ART29_ERRO_IMPRESSAO_RECEBIDO':
            return {...state, esperandoImpressao: false, urlRedirect: '/artigo29/iserror' };

        case 'ART29_ERRO_ELO':
            return { ...state, esperandoSolicitacao: false, error_elo: true };      
        case 'ART29_RESET_REDIRECT':
            return { ...state, urlRedirect: "" };   

        default:
            return state;
    }
}